import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import smiling from '../../assets/icon/smiling.svg';
import star from '../../assets/icon/star.svg';
import Button from './button';

const Article = Styled.article`
max-width: 50rem;
display: block;
background-color ${color.white};
border: solid 1px ${color.light};
border-radius: 5px;
padding: 2rem 2rem;

display: grid;
grid-template-columns: max-content 1fr max-content;
place-items: center;
grid-gap: 2rem;
`;
const ArticleAvatar = Styled.figure`
height: 5rem;
width:5rem;
border-radius: 100rem;
background-color: ${color.secondaryAlt};
img{width: 100%;height: 100%; object-fit: cover;}
`;

const ArticleText = Styled.div`
align-self: flex-start;
justify-self: flex-start;
`;
const ArticleParagraph = Styled.p`
color:${color.primaryAlt};
font-size: 1.5rem;
`;
const ArticleName = Styled.h4`
color:${color.primary};`;

const SitterProfile = ({ name, rating, image }) => {
  return (
    <Article>
      <ArticleAvatar>
        <img src={image || smiling} alt="" />
      </ArticleAvatar>
      <ArticleText>
        <ArticleParagraph>Your sitter</ArticleParagraph>
        <ArticleName>{name || 'Not Assigned Yet'}</ArticleName>
        <ArticleParagraph>
          {rating
            ? `${rating} rating`
            : 'Sitters are assigned 72 hours before service'}
        </ArticleParagraph>
      </ArticleText>
      {name && <Button type="light" icon={star} text="Reviews" />}
    </Article>
  );
};

export default SitterProfile;
